import styles from "./PartnerBand.module.scss";
import { resolveIcon } from "./iconMap";

/**
 * Icon + label band. Two Figma treatments, selected by `surface`:
 *
 * - `grey`/`light` (essential-oil `5594-7846`) — left-aligned heading + intro,
 *   BORDERLESS icon-circle + label rows on a 2-up grid whose later columns are
 *   indented 40px.
 * - `dark` (chemical-toll `4673-18490`) — centered heading + intro on navy, and
 *   the rows become BORDERED cards laid out flex-wrap so a partial last row
 *   centres itself under the full rows above.
 *
 * Items are data throughout: card count = items.length, track count = `columns`.
 */
export default function PartnerBand({
  heading,
  body,
  items = [],
  columns = 2,
  surface = "grey",
}) {
  if (!items.length && !heading) return null;
  const paras = Array.isArray(body) ? body : body ? [body] : [];

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {paras.map((p, i) => (
          <p className={styles.para} key={i}>
            {p}
          </p>
        ))}

        {items.length > 0 && (
          <ul
            className={styles.list}
            style={{ "--cols": columns }}
            data-cols={columns}
          >
            {items.map((item, i) => (
              <li className={styles.item} key={i}>
                <span className={styles.iconWrap}>
                  <img src={resolveIcon(item.icon)} alt="" aria-hidden="true" />
                </span>
                <span className={styles.label}>{item.title}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
